var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 521,
    viewBox: "0 0 1440 521",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.152832,
    width: 1440,
    height: 512,
    fill: "url(#paint0_linear_326_35650)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_326_35650",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 513
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.152832,
    width: 1440,
    height: 512,
    fill: "url(#paint1_linear_326_35650)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_326_35650)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter0_dd_326_35650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1271.79 56.8543L867.307 -347.507C864.631 -350.194 861.451 -352.325 857.949 -353.78C854.448 -355.234 850.693 -355.983 846.902 -355.983C843.11 -355.983 839.356 -355.234 835.854 -353.78C832.353 -352.325 829.173 -350.194 826.497 -347.507L725.407 -246.359L1048.85 77.2007L612.015 514.093L713.164 615.358C715.84 618.045 719.02 620.176 722.521 621.631C726.023 623.085 729.777 623.834 733.569 623.834C737.36 623.834 741.114 623.085 744.616 621.631C748.118 620.176 751.297 618.045 753.973 615.358L1271.84 97.4887C1277.21 92.0839 1280.21 84.7745 1280.2 77.1595C1280.19 69.5444 1277.16 62.2437 1271.79 56.8543Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_326_35650",
    x: 608.015,
    y: -355.983,
    width: 676.187,
    height: 987.817,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_326_35650"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_326_35650",
    result: "effect2_dropShadow_326_35650"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_326_35650",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_326_35650",
    x1: 0.00000686814,
    y1: 512.153,
    x2: 990.273,
    y2: -458.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272966"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_326_35650",
    x1: 0.00000686814,
    y1: 512.153,
    x2: 990.273,
    y2: -458.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272966"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.881c39723dcaa438a40f2f5e48bfdc1d.svg";
export { ForwardRef as ReactComponent };